export default "__VITE_ASSET__C9zWej01__"